import { render, staticRenderFns } from "./superGraph.vue?vue&type=template&id=2645b944&scoped=true"
import script from "./superGraph.vue?vue&type=script&lang=js"
export * from "./superGraph.vue?vue&type=script&lang=js"
import style0 from "./superGraph.vue?vue&type=style&index=0&id=2645b944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645b944",
  null
  
)

export default component.exports